import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client';

import { useGoogleSdk } from '../../Authentication.hooks';
import { platform_base_url } from '../../../../util/config';
import { post } from '../../../../util/request';
import { completeAuthentication } from '../../Authentication.utils';
import { trackEvent } from '../../../../util/track';

import * as Styled from './GoogleSignInButton.styled';

const GoogleSignInButton = ({ onComplete, setIsLoading }) => {
  const client = useApolloClient();
  const isGoogleReady = useGoogleSdk();

  const handleGoogleAuth = async ({ credential }) => {
    setIsLoading(true);
    post(
      `${platform_base_url}/v2/identity/social/google`,
      {
        access_token: credential
      },
      { credentials: 'include' }
    )
      .then(completeAuthentication.bind(null, client))
      .then(onComplete.bind(null, { id: credential, method: 'google' }));
  };

  useEffect(() => {
    try {
      if (isGoogleReady) {
        window.google.accounts.id.initialize({
          client_id:
            '32421629339-3s5nh3ui9o69japn1bcscc2l9365kdlj.apps.googleusercontent.com',
          callback: handleGoogleAuth
        });

        window.google.accounts.id.renderButton(
          document.getElementById('google-sign-in'),
          {
            theme: 'outline',
            size: 'medium',
            text: 'continue_with',
            width: 272
          }
        );

        window.addEventListener('message', (event) => {
          if (
            event.origin === 'https://accounts.google.com' &&
            event.data.channelId
          ) {
            trackEvent({ event: 'googleButtonClick' });
          }
        });
      }
    } catch (e) {
      window.DD_RUM?.addError(new Error('Error with Google API'), {
        location: 'identity/social/google'
      });
    }
  }, [isGoogleReady]);

  return <Styled.GoogleSignInButton />;
};

GoogleSignInButton.propTypes = {
  /**
   * Callback on successful submission of google login form
   */
  onComplete: PropTypes.func.isRequired,
  /**
   * Updates the loading state of the form
   */
  setIsLoading: PropTypes.func.isRequired
};

export default GoogleSignInButton;
